import {useState} from 'react';
import PropTypes from 'prop-types';
import {MAX_TITLE_LENGTH, MAX_DESCRIPTION_LENGTH} from '../validation';

export default function NewTemplateModal({onConfirm, onCancel}) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    function submit() {
        const n = name.trim();
        if (!n) return;
        onConfirm(n, description.trim());
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') submit();
        if (e.key === 'Escape') onCancel();
    }

    return (
        <div
            className="modal-backdrop template-modal"
            onClick={onCancel}
            onKeyDown={e => e.key === 'Escape' && onCancel()}
            role="presentation"
        >
            <div
                className="modal"
                onClick={e => e.stopPropagation()}
                onKeyDown={e => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <h3 className="modal-title">New Template</h3>
                <input
                    className="modal-input"
                    type="text"
                    placeholder="Template name"
                    value={name}
                    maxLength={MAX_TITLE_LENGTH}
                    onChange={e => setName(e.target.value)}
                    onKeyDown={handleKeyDown}
                    autoFocus
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck={false}
                />
                <input
                    className="modal-input"
                    type="text"
                    placeholder="Description (optional)"
                    value={description}
                    maxLength={MAX_DESCRIPTION_LENGTH}
                    onChange={e => setDescription(e.target.value)}
                    onKeyDown={handleKeyDown}
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck={false}
                />
                <div className="modal-actions">
                    <button className="modal-cancel" onClick={onCancel}>
                        Cancel
                    </button>
                    <button className="modal-confirm" onClick={submit} disabled={!name.trim()}>
                        Create
                    </button>
                </div>
            </div>
        </div>
    );
}

NewTemplateModal.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};
